/**
 * 启动时根据 cookie 引导登录态：有效 → isLogin=true，否则 isLogin=false。
 * 必须在 route middleware 之前完成（Nuxt 会 await async 插件）。
 */
export default defineNuxtPlugin(async () => {
  const authStore = useAuthStore();
  await authStore.bootstrap();
});
